import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(theme => {
  var _theme$palette, _theme$palette2, _theme$palette3, _theme$palette4;
  return {
    comingSoonChip: {
      marginLeft: 8
    },
    titleRow: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 16
    },
    statusSelect: {
      height: 28,
      '& .MuiSelect-select': {
        padding: '0 8px 0 0 !important',
        minHeight: 'unset',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'transparent'
      },
      '& .MuiSelect-icon': {
        right: -4,
        position: 'static',
        color: 'inherit'
      },
      cursor: 'pointer'
    },
    statusValue: {
      fontSize: 14,
      fontWeight: 600,
      lineHeight: 1
    },
    content: {
      padding: '0 4px'
    },
    field: {
      marginBottom: 24,
      '&:last-child': {
        marginBottom: 0
      }
    },
    fieldLabel: {
      marginBottom: 12,
      fontWeight: 600
    },
    discountRow: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 16
    },
    discountType: {
      flex: 1,
      minWidth: 0
    },
    discountValue: {
      width: 120,
      flexShrink: 0
    },
    codeInput: {
      '& .MuiInputBase-input': {
        fontFamily: 'monospace'
      }
    },
    inlineControl: {
      marginTop: 12
    },
    customNumberInput: {
      width: 220
    },
    productsList: {
      marginTop: 12,
      display: 'flex',
      flexDirection: 'column',
      border: "1px solid ".concat(((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : _theme$palette.divider) || '#e0e0e0'),
      borderRadius: 4
    },
    productsListItem: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '2px 8px',
      borderBottom: "1px solid ".concat(((_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.divider) || '#e0e0e0'),
      '&:last-child': {
        borderBottom: 'none'
      }
    },
    helperText: {
      marginTop: 6,
      fontSize: 12,
      color: ((_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 || (_theme$palette3 = _theme$palette3.text) === null || _theme$palette3 === void 0 ? void 0 : _theme$palette3.secondary) || '#666'
    },
    errorText: {
      marginTop: 6,
      fontSize: 12,
      color: ((_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 || (_theme$palette4 = _theme$palette4.error) === null || _theme$palette4 === void 0 ? void 0 : _theme$palette4.main) || '#d32f2f'
    }
  };
});
export default useStyles;